import { TextField } from '@material-ui/core'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 2rem;
  box-shadow: -12px 0px 16px 0px #0000000a inset;

  overflow: auto;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 100%;
`

export const HeaderSection = styled.section`
  width: 100%;
  height: 100%;

  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  color: #5b5b76;
  margin-bottom: 2rem;

  & > span {
    font-weight: 400;
  }
`

export const Section = styled.p`
  display: flex;
  align-items: center;

  font-family: 'Inter', sans-serif;
  font-weight: 500;

  margin-top: 1rem;

  & > svg {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }
`

export const Title = styled.h3`
  font-size: 1.5rem;
  color: #5b5b76;
  font-weight: bold;
  font-family: 'Commissioner', sans-serif;
`

export const ImagePreviewContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  margin: 16px 0;
  width: 100%;
  gap: 16px;
`

export const Subtitle = styled.p`
  font-size: 0.625rem;
  font-weight: 400;
  text-align: left;
  color: #9a9ab1;
`

export const TextInput = styled(TextField)`
  font-family: 'Roboto', sans-serif;
  width: 100%;

  margin: 16px 0 !important;

  label {
    color: #949494;
    font-size: 0.875rem;
  }
  fieldset {
    border-color: #c4c4c4;
  }

  input {
    color: #263238;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e3e3e8;
  margin: 16px 0;
`

const Label = styled.label`
  border: solid 2px #5b5b76;
  border-radius: 50px;
  padding: 11px 0;
  width: 100%;
  text-align: center;

  cursor: pointer;
  background-color: transparent;

  color: #5b5b76;
  font-size: 0.875rem;
  font-weight: 700;
  font-family: 'Commissioner', sans-serif;

  svg {
    margin-left: 8px;
  }
`

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding-bottom: 2rem;

  width: 100%;
`

const DefaultButton = styled.button`
  border-radius: 50px;
  padding: 11px 0;
  width: 100%;

  border: 2px solid #2a3ecb;
  color: #2a3ecb;

  cursor: pointer;
  background-color: transparent;

  font-weight: 700;
  font-size: 0.875rem;
  font-family: 'Commissioner', sans-serif;
`

export const UploadLabelButton = styled(Label)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;

  svg {
    margin-left: 8px;
  }
`

export const FooterSaveButton = styled(DefaultButton)`
  &:disabled {
    border-color: #babac5;
    color: #babac5;
    cursor: not-allowed;
  }
`

export const FooterDeleteButton = styled(DefaultButton)`
  border: 0;
  color: #f34456;
`

export const FooterCancelButton = styled(DefaultButton)`
  border-color: #5b5b76;
  color: #5b5b76;
`
